import { DOCUMENT } from '@angular/common';
import { inject, Injectable, REQUEST_CONTEXT } from '@angular/core';
import { EnvironmentService } from '@core/services/environment.service';
import cookie from 'cookie';

@Injectable({
    providedIn: 'root',
})
export class CookieService {
    private environmentService = inject(EnvironmentService);
    private document = inject(DOCUMENT);
    private requestContext = inject(REQUEST_CONTEXT, {
        optional: true,
    }) as { cookies: {} };

    private get cookies() {
        if (this.environmentService.isBrowser()) {
            return cookie.parse(this.document.cookie);
        } else {
            return this.requestContext?.cookies || {};
        }
    }

    getCookie(key: string) {
        return this.cookies[key];
    }
    setCookie(key: string, value: string, ttl: number) {
        if (this.environmentService.isBrowser()) {
            this.document.cookie = cookie.serialize(key, value, {
                maxAge: ttl,
                sameSite: 'lax',
                path: '/',
                secure: true,
            });
        }
    }

    deleteCookie(key: string) {
        if (this.environmentService.isBrowser()) {
            this.document.cookie = cookie.serialize(key, '', {
                expires: new Date(0),
                sameSite: 'lax',
                path: '/',
                secure: true,
            });
        }
    }
}
